import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HistoryModule } from '@/services/history/history.module';
import { AIDisclosureModule } from '@/services/ai-disclosure/ai-disclosure.module';

export const documentModule = new ContainerModule((bind) => {
    HistoryModule(bind);
    AIDisclosureModule(bind);
});
